<template>
    <div class="align-center-helper">
        <infobox-generic
        v-if="headerData && headerData.code === 'signed_operation_edit'"
        :label="headerData.additionalMessage"/>
        <!-- Operator info divider -->
        <divider-generic icon="person" :applyBorder="false" :title="t('approvals.operators.edit.step2.dataDivider')"/>
        <!-- Username Output -->
        <text-block-generic
        :params="{ label: t('approvals.operators.edit.step2.accessionNumberLabel'), content: operatorData.username.value }"/>
        <!-- Name Input -->
        <text-block-generic
        :params="{ label: t('approvals.operators.edit.step2.nameLabel'), content: operatorData.name.value }"/>
        <!-- E-mail Input -->
        <text-block-generic
        :params="{ label: t('approvals.operators.edit.step2.emailLabel'), content: operatorData.email.value }"/>
        <!-- Phone Number Input -->
        <text-block-generic
        :params="{ label: t('approvals.operators.edit.step2.phoneLabel'), content: operatorData.msisdn.value }"/>
        <!-- Nif Input -->
        <text-block-generic
        :params="{ label: t('approvals.operators.edit.step2.nifLabel'), content: operatorData.nif.value || '-' }"/>
        <!-- New Accounts -->
        <text-block-generic
        :params="{
            label: t('approvals.operators.edit.step2.accessLabel'),
            content: operatorData.accessToNewAccounts.value ? t('approvals.operators.edit.step2.radioYes')  : t('approvals.operators.edit.step2.radioNo')
        }"/>
        <!-- Profile -->
        <text-block-generic
        :params="{
            label: t('approvals.operators.edit.step2.profileLabel'),
            content: getProfilesForDropdown.find(ele => ele.id === operatorData.profileId.value).text
        }"/>
        <!-- Weight Input -->
        <text-block-generic
        v-if="operatorData.profileId.value === 1"
        :params="{
            label: t('approvals.operators.edit.step2.weightLabel'),
            content: `${operatorData.weight.value}%`
        }"/>
        <!-- Accounts Divider -->
        <divider-generic icon="lock" :title="t('approvals.operators.edit.step2.accountsDivider')"/>
    </div>
    <!-- Accounts Block -->
    <account-accessed-block
    v-for="account in accountsData"
    createOperatorStyles
    :key="account.id"
    :account="account"
    :defaultAccount="operatorData.defaultAccountId.value"/>
</template>

<script setup>
import DividerGeneric from '@/components/generic/dividers/Generic'
import InfoboxGeneric from '@/components/generic/infobox/Generic'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'
import AccountAccessedBlock from '@/components/features/approvals/operators/details/AccountAccessedBlock'

/* Vue & Assets */
import { computed } from 'vue'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* mapActions & mapGetters */
const { getProfilesForDropdown, getOperationsTypesList } = mapGetters(moduleMapper.APPROVALS_OPERATORS)

/* Emmitters */
const emit = defineEmits(['createNewOperator'])

const props = defineProps({
    operatorData: Object,
    accounts: Array,
    headerData: Object
})

const accountsData = computed(() => {
    return props.accounts.map(account => {
        return {
            account: {
                ...account
            },
            operationLimits: account.operationLimits.map(operation => {
                return {
                    operationType: {
                        ...operation.operationType,
                        name: getOperationsTypesList.value.find(ele => ele.id === operation.operationType.value).type
                    },
                    dailyPlafond: operation.plafond.value,
                    transactionLimit: operation.transactionLimit.value
                }
            })
        }
    })
})

</script>

<style lang="scss" scoped>
.align-center-helper {
    width: 508px;
    max-width: 100%;

    display: flex;
    flex-direction: column;
    gap: 24px;
}
</style>
